import { ChangeEvent, useState } from 'react';
import { useOperator } from '../../contexts/OperatorContext';
import { Select } from '../Select';
import { SelectItem } from '../Select';
import { MenuItem } from '../../types/commonTypes';
import clsx from 'clsx';

interface Props {
  className?: string;
  disabled?: boolean;
  listAll: boolean;
  onSelect(item: string): void;
  defaultValue?: string;
  isRequired?: boolean;
  [x: string]: any;
}

export const AccountSiteSelect = ({
  className,
  listAll,
  loading,
  onSelect,
  defaultValue = '',
  isRequired = false,
  disabled = false,
  ...rest
}: Props) => {
  const [site, setSite] = useState(defaultValue);
  const operator = useOperator();
  const allSites = (operator.sites ?? []).reduce(
    (arr: MenuItem[], site) => {
      arr.push({
        id: site.id,
        name: site.name,
      });
      return arr;
    },
    listAll ? [{ id: 'all', name: 'All' }] : []
  );

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSite(event.target.value);
    onSelect(event.target.value);
  };

  return (
    <Select
      className={clsx(className, 'children:w-fit')}
      disabled={disabled}
      labelId="site-select-label"
      id="site-select"
      label={!isRequired ? 'Site:' : undefined}
      helperText={isRequired ? '*Required' : undefined}
      placeholder={isRequired ? 'Site' : undefined}
      required={isRequired}
      value={site}
      onChange={handleChange}
      variant="contained"
      {...rest}
    >
      {allSites.map((site) => (
        <SelectItem key={site.id} value={site.id}>
          {site.name}
        </SelectItem>
      ))}
    </Select>
  );
};
